export class PagedResponse<T> {
    page: number;
    pageCount: number;
    pageSize: number;
    rowCount: number;
    totalRowCount: number;
    results : T;
}
